import React, { useState } from "react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  Checkbox,
  Chip,
} from "@bst/react-ui"
import { useTranslation } from "react-i18next";
import clsx from 'clsx';
import { RoleDTO } from '../../../apiclients/bstinsights';

type Props = {
  label: string;
  disabled?: boolean
  dataSource: Required<RoleDTO>[]
  selectedRoles: number[]
  handleUserRoles: (roleId: number) => void
};

export const RolesDropdown = ({
  label,
  disabled,
  dataSource,
  selectedRoles,
  handleUserRoles
}: Props) => {
  const { t } = useTranslation();
  const [open, setIsOpen] = useState(false);
  const selectedData = dataSource.filter((source) => selectedRoles?.includes(source.roleId))
  const hasSelected = selectedRoles && selectedRoles.length > 0;
  const isActive = open || hasSelected;
  const handleOpen = (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    const target = event.target as HTMLElement
    if (disabled || target.classList.contains('icon-close') || target.classList.contains('bst-ui__chip__text')) {
      return;
    }
    setIsOpen(true)
  }
  const handleSelect = (roleId: number, event?: Event) => {
    event?.preventDefault()
    if (disabled) {
      return
    }
    handleUserRoles(roleId)
  }
  const renderSelectedChips = selectedData.map((item) => (
    <Chip
      key={item.roleId}
      text={item.roleName}
      onClose={() => handleSelect(item.roleId)}
    />
  ))
  const renderCheckboxes = dataSource.map((item) => (
    <DropdownMenuItem
      key={item.roleId}
      onSelect={(event) => handleSelect(item.roleId, event)}
    >
      <Checkbox
        invertColors
        label={item.roleName}
        data-testid={`role-item-${item.roleName}`}
        checked={selectedRoles?.includes(item.roleId)}
      />
    </DropdownMenuItem>
  ))
  const renderNoItems = <DropdownMenuItem>{t("userManagementPage.no_roles")}</DropdownMenuItem>
  return (
    <DropdownMenu
      open={open}
      onOpenChange={setIsOpen}
    >
      <DropdownMenuTrigger
        disabled={disabled}
        className="roles-dropdown-trigger"
      >

      </DropdownMenuTrigger>
      <div className="roles-dropdown-trigger">
        <div
          data-testid="roles-dropdown-trigger"
          className={clsx("bst-ui__input-control", disabled && "roles-dropdown-trigger--disabled")}
          onClick={handleOpen}
        >
          <div
            className={clsx("bst-ui__input", isActive && "bst-ui__input--active")}
            data-testid="bst-ui-input-state-control"
          >
            <i className="icon icon-pricing" />
            <div className="bst-ui__input__container">
              <div className="selected-roles-list">
                {renderSelectedChips}
              </div>
              <label className="bst-ui__input__label">{label}</label>
            </div>
          </div>
        </div>
        <i className={clsx(["icon", "trigger-chevron", { "icon-chevron-down": !open, "icon-chevron-up": open }])} />
      </div>
      <DropdownMenuContent
        side="top"
        align="start"
        collisionPadding={8}
        sideOffset={8}
        className="roles-dropdown-content"
      >
        {dataSource.length > 0 ? renderCheckboxes : renderNoItems}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};